const faqs = [
  {
    q: "黑料吃瓜网的内容来源是什么？",
    a: "我们的内容来源于全网公开的娱乐资讯、社交媒体热点、用户投稿以及专业编辑的整理汇编。所有内容均经过审核团队核实后发布，确保真实性和时效性。",
  },
  {
    q: "黑料吃瓜网是否收费？",
    a: "完全免费！黑料吃瓜网承诺永久免费向所有吃瓜群众开放。我们通过品牌广告合作来维持平台运营，不会向用户收取任何费用。",
  },
  {
    q: "如何向黑料吃瓜网投稿爆料？",
    a: "你可以通过本页面的「商务合作与爆料通道」提交爆料内容，也可以通过官方邮箱 hello@cgiqwhk.cn 发送独家内幕。我们会对每一条投稿进行核实，一经采纳将注明来源并给予相应奖励。",
  },
  {
    q: "如何保证爆料的真实性和隐私安全？",
    a: "我们拥有专业的审核团队对所有投稿内容进行多方交叉验证。同时，我们严格保护投稿人的隐私信息，所有爆料来源均会进行匿名化处理，绝不泄露投稿人身份。",
  },
  {
    q: "如果发现内容侵权，应该如何申诉？",
    a: "如您认为平台上的内容侵犯了您的合法权益，请通过官方邮箱 hello@cgiqwhk.cn 发送侵权通知，我们将在24小时内核实并处理。你也可以通过联系表单提交申诉，我们会在第一时间响应。",
  },
];

export default function FAQ() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-10 max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            关于黑料吃瓜网，你可能想了解的事
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-xl cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-900 list-none">
                <span>{faq.q}</span>
                <i className="ri-arrow-down-s-line text-foreground-400 w-5 h-5 flex items-center justify-center transition-transform duration-200 group-open:rotate-180"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}